import { render } from "./avatarUpload.vue?vue&type=template&id=c1e30426&scoped=true"
import script from "./avatarUpload.vue?vue&type=script&lang=js"
export * from "./avatarUpload.vue?vue&type=script&lang=js"

import "./avatarUpload.vue?vue&type=style&index=0&id=c1e30426&lang=less&rel=stylesheet&scoped=true"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1e30426"]])

export default __exports__